import { subscriptionDetails as EnUsSubscriptionDetails } from '../en-us/subscriptionDetails';
import { AgResourceLanguage } from '../types';

export const subscriptionDetails: AgResourceLanguage['subscriptionDetails'] = {
  ...EnUsSubscriptionDetails,
  orderFields: {
    ...EnUsSubscriptionDetails.orderFields,
    subscriptionTextBtn: 'Añadir Producto a la Suscripción',
    subscriptionSubtotal: 'Subtotal de la Suscripción',
    nextSubtotal: 'Subtotal de Añadidos Únicos',
    nextTextBtn: 'Añadir Producto al Próximo Pedido',
    subscriptionTitle: 'Productos de Suscripción',
    nextTitle: 'Añadidos Únicos'
  },
  active: {
    ...EnUsSubscriptionDetails.active,
    exploreButton: 'Añadir producto',
    free: 'Gratis',
    shippingAddress: 'Dirección de envío',
    subscriptionButton: 'Añadir Productos',
    orderTotal: 'Total del Pedido:',
    nextOrderButton: 'Añadir Producto al Próximo Pedido',
    emtyTitle: 'Añadidos Únicos:',
    qty: 'x',
    subscriptionProductsTitle: 'Productos de Suscripción',
    lastOrderDetails: 'Detalles del Último Pedido',
    backButton: 'Volver a la Lista',
    emptyText:
      'Compra toda la gama de productos y accesorios AG1, disponibles exclusivamente para miembros.',
    emptyButton: 'Añadir Producto al Próximo Pedido',
    nextOrderLabel: 'Próxima Fecha de Pedido:',
    addOns: 'Añadidos Únicos:',
    nextShipmentTitle: 'Próximo Pedido'
  },
  reactivate: {
    ...EnUsSubscriptionDetails.reactivate,
    headline:
      'Tu suscripción ha sido cancelada y se enviará una confirmación por correo electrónico a {{email}}.',
    title: 'En caso de que nos extrañes...',
    subTitle:
      '¡Nos encantaría que volvieras! ¿Sabías que estas opciones facilitan saltarse un envío o aprovechar al máximo tu suscripción de AG1?',
    agzSubTitle:
      '¡Nos encantaría tenerte de vuelta! Puedes iniciar sesión y reiniciar tu suscripción en cualquier momento haciendo clic en "Reactivar".',
    reactivateOfferCard: {
      delay: {
        heading: '"Tengo demasiado."',
        text: '¿Necesitas un poco de tiempo para ponerte al día? Retrasa tu próximo envío de AG1.',
        btnText: 'Reactivar & Retrasar'
      },
      skip: {
        heading: '"Tengo demasiado."',
        text: '¿Necesitas un poco de tiempo para ponerte al día? Salta tu próximo envío de AG1.',
        btnText: 'Reactivar & Saltar'
      },
      switch: {
        heading: '"Estoy con un presupuesto ajustado."',
        textTwoPouches:
          'Cambia a 2 bolsas enviadas cada 60 días para aprovechar los precios exclusivos para miembros con menos envíos (un valor de {{symbolCurrency}}18).',
        textThreePouches:
          'Cambia a 3 bolsas enviadas cada 90 días para aprovechar los precios exclusivos para miembros y el envío gratuito, con un valor de {{symbolCurrency}}42.',
        btnText: 'Reactivar & Cambiar'
      },
      upgrade: {
        heading: '“No me gusta el sabor.”',
        text: 'Con un clic, cambia tu suscripción a nuestra fórmula mejorada con más probióticos, nutrientes y un nuevo sabor tropical.',
        learnMoreLinkText: 'Obtenga más información.',
        btnText: 'Reactivar y actualizar'
      }
    }
  },
  reactivateConfirm: {
    ...EnUsSubscriptionDetails.reactivateConfirm,
    title: 'Confirma tu nuevo plan',
    tableHead: 'Se te facturará el:',
    tableSubHead: 'Has desbloqueado un',
    tableSubHeadValue: 'valor',
    tableSubHeadOn: 'con',
    subTotal: 'Subtotal',
    shipping: 'Envío',
    free: 'GRATIS',
    total: 'Total',
    confirmButton: 'Confirmar',
    cancelButton: 'No, gracias',
    offer: {
      subtitleThreePouches:
        'Reactiva tu suscripción y aprovecha los precios exclusivos para miembros y el envío gratis — un valor de {{symbolCurrency}}42.',
      subtitleTwoPouches:
        'Reactiva tu suscripción y aprovecha los precios exclusivos para miembros con menos envíos, un valor de 18 {{symbolCurrency}}.',
      promotionText: '{{pouches}} bolsas y menos envíos.'
    },
    newPlan: {
      title: 'Tu nuevo plan AG1:',
      titleSecondary: 'Tu AG1 se enviará el:',
      mainText: '{{pouches}} bolsas enviadas cada {{days}} días',
      nextShipment: 'Próximo envío:'
    }
  },
  reactivateSuccess: {
    ...EnUsSubscriptionDetails.reactivateSuccess,
    title: '¡Nos alegra tenerte de vuelta!',
    subBtn: 'Ver mi suscripción',
    learnMore: {
      title: 'Nutrición fundamental en una sola cucharada',
      text: 'Cada cucharada de AG1 contiene los beneficios para la salud de todo el cuerpo que necesitasen un simple hábito diario.*',
      btnText: 'Más información'
    },
    offer: {
      skip: 'Hemos reactivado tu membresía y saltado tu próximo envío. Vamos a cuidar nuestra salud juntos.',
      delay:
        'Hemos reactivado tu membresía y retrasado tu próximo envío. Vamos a cuidar nuestra salud juntos.',
      default: 'Hemos reactivado tu membresía. Vamos a cuidar de nuestra salud juntos.'
    }
  },
  v2: {
    ...EnUsSubscriptionDetails.v2,
    active: {
      ...EnUsSubscriptionDetails.v2.active,
      nextOrderTitle: 'Próximo Pedido',
      shippingFrequency: 'Frecuencia de Envío',
      item: 'Cada'
    },
    editFrequency: {
      day: 'Día'
    },
    orderItems: {
      subscriptionDescription: 'Suscripción',
      nextOrderOnlyDescription: 'Solo este pedido',
      toBeAppliedAfterNextOrder: 'A aplicarse después del próximo pedido'
    },
    reactivate: {
      success: 'Tu suscripción ha sido reactivada'
    },
    errors: {
      apiError: 'Nous rencontrons un problème technique temporaire. Veuillez réessayer plus tard.'
    }
  }
};
